module.exports = __webpack_public_path__ + "img/w6b.a3045c8f.jpg";